@use 'src/core/styles/mediaQueries';
@use '../mixins';

button {
  margin: 0;
  // Button Resets
  padding: 0;
  border: 0;
  background-color: transparent;
  color: inherit;
  font-family: inherit;
  font-size: 100%;
  font-weight: normal;
  line-height: normal;
  vertical-align: baseline;
  cursor: pointer;
  appearance: unset;

  &:disabled {
    cursor: not-allowed !important;
  }

  &:active {
    color: currentColor;
  }
}

@mixin loading-spinner($activeColor: '#FFF', $selector: '&::before', $time: 1.2s) {
  // These styles are being applied the element
  // where we include the mixin. I'd recommend for
  // maintainability to keep these as minimal as possible.
  position: relative;
  width: 3em;
  margin: auto;

  // Animation Keyframes
  @keyframes spinner-animation {
    0% {
      transform: translate3d(-50%, -50%, 0) rotate(0deg);
    }

    100% {
      transform: translate3d(-50%, -50%, 0) rotate(360deg);
    }
  }

  // Spinner
  #{$selector} {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1.666em;
    height: 1.666em;
    transform: translate3d(-50%, -50%, 0);
    transform-origin: center;
    animation: spinner-animation $time linear infinite;
    border: 0.1666em solid transparent;
    border-radius: 50%;
    border-bottom-color: $activeColor;
    opacity: inherit;

    will-change: transform;
  }
}

.btn {
  --color-primary: #fff;
  --color-disabled-primary: #fff;
  --bg-color-default-primary: var(--color-orange-1);
  --bg-color-hover-primary: #db8a21;
  --bg-color-disabled-primary: #efc289;

  --color-secondary: #fff;
  --color-disabled-secondary: #fff;
  --bg-color-default-secondary: var(--dark-blue-500);
  --bg-color-hover-secondary: #031732;
  --bg-color-disabled-secondary: var(--dark-blue-300);

  --color-tertiary: var(--dark-blue-500);
  --color-disabled-tertiary: var(--dark-blue-300);
  --bg-color-default-tertiary: var(--dark-blue-200);
  --bg-color-hover-tertiary: var(--dark-blue-500);
  --bg-color-disabled-tertiary: var(--dark-blue-300);

  width: 100%;
  border-radius: 0.125rem;

  @include mediaQueries.tablet {
    width: unset;
  }

  &.fill {
    width: 100%;
  }

  &.noFill {
    width: unset;
  }

  &.bold {
    font-weight: bold;
  }

  &.small {
    font-size: var(--font-size-nav);
  }

  &.underlined {
    text-decoration: underline;
  }

  // Default hover styles (no intent buttons)
  &:hover,
  &:focus {
    color: var(--light-blue-500);
  }

  &.primary {
    @include mixins.cta-intent-styles-generator(
      var(--color-primary),
      var(--bg-color-default-primary),
      var(--color-disabled-primary),
      var(--bg-color-disabled-primary),
      var(--bg-color-hover-primary)
    );

    .loadingSpinner {
      @include loading-spinner(var(--color-primary));
    }
  }

  &.secondary {
    @include mixins.cta-intent-styles-generator(
      var(--color-secondary),
      var(--bg-color-default-secondary),
      var(--color-disabled-secondary),
      var(--bg-color-disabled-secondary),
      var(--bg-color-hover-secondary)
    );

    .loadingSpinner {
      @include loading-spinner(var(--color-secondary));
    }
  }

  &.tertiary {
    @include mixins.outlined-cta-intent-styles-generator(
      var(--color-tertiary),
      var(--bg-color-default-tertiary),
      var(--color-disabled-tertiary),
      var(--bg-color-disabled-tertiary),
      var(--bg-color-hover-tertiary)
    );

    .loadingSpinner {
      @include loading-spinner(var(--color-tertiary));
    }
  }

  &.loading {
    &.primary:disabled {
      background-color: var(--bg-color-default-primary);
    }

    &.secondary:disabled {
      background-color: var(--bg-color-default-secondary);
    }

    &.tertiary:disabled {
      border: 0.08333em solid var(--bg-color-disabled-tertiary);
      color: var(--color-disabled-tertiary);
    }
  }
}

.toggleBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 1em 0.5em;
  border-radius: 0.1666em;
  font-size: var(--font-size-nav);
  letter-spacing: 0.125rem;
  text-transform: uppercase;
  user-select: none;
}

.backButton {
  display: flex;
  align-items: center;

  svg {
    transform: rotate(180deg);
  }
}
